"use client";

import { MapPin, Users, Zap, Award, ShieldCheck, Star } from 'lucide-react';
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ServiceArea() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const serviceAreas = [{
    name: "Calgary"
  }, {
    name: "Airdrie"
  }, {
    name: "Okotoks"
  }, {
    name: "Cochrane"
  }, {
    name: "Chestermere"
  }];
  const trustFeatures = [{
    icon: Users,
    title: "Local Experts",
    desc: "Calgary based team"
  }, {
    icon: Zap,
    title: "Fast Response",
    desc: "Quick site visits"
  }, {
    icon: Award,
    title: "Premium Quality",
    desc: "Top-tier materials"
  }, {
    icon: ShieldCheck,
    title: "Fully Insured",
    desc: "Your home protected"
  }, {
    icon: Star,
    title: "Satisfaction Guaranteed",
    desc: "We stand behind our work"
  }];
  return <section data-section-id="9281" id="serving-the-calgary-region" className="bg-white text-secondary overflow-hidden relative border-t border-border ![padding:65px_0px_40px_0px]">
      {}
      <div className="absolute top-12 right-8 hidden md:block">
        <div className="flex items-center gap-4">
          
          
        </div>
      </div>

      <div ref={ref} className={`max-w-[1440px] mx-auto px-6 md:px-8 transition-all duration-700 cubic-bezier(0.16, 1, 0.3, 1) ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-16 lg:gap-24 items-center">
          
          {}
          <div className="lg:col-span-5">
            <div className="inline-flex items-center gap-3 mb-6">
              <span className="font-mono text-[0.75rem] font-bold uppercase tracking-[0.2em] text-primary">
                Service Coverage
              </span>
            </div>

            <h2 className="font-sans font-bold mb-8 text-secondary text-4xl md:text-5xl lg:text-6xl tracking-tighter leading-[1.1]">
              Proudly Serving <span className="text-primary">Calgary</span> & Surrounding Communities
            </h2>

            <div className="space-y-6 mb-12">
              <p className="font-sans text-lg text-secondary/70 leading-relaxed">
                MetalLine Exteriors provides premium metal roofing, siding, and architectural cladding solutions throughout Calgary and the surrounding areas. Our team is committed to delivering exceptional craftsmanship, premium materials, and outstanding customer service on every project.
              </p>
              <p className="font-sans text-lg text-secondary/70 leading-relaxed">
                From minor upgrades to full exterior renovations, we're proud to help homeowners across Southern Alberta protect and increase the value of their homes.
              </p>
            </div>

            <div className="mb-12">
              <h4 className="font-sans font-bold text-sm text-secondary uppercase tracking-wider mb-6">Areas We Serve</h4>
              <div className="flex flex-wrap gap-3">
                {serviceAreas.map((area, i) => <div key={area.name} data-index={i} className="flex items-center gap-2 px-4 py-2 bg-accent/50 border border-border rounded-lg">
                    <MapPin className="size-4 text-primary" />
                    <span className="font-sans font-medium text-sm">{area.name}</span>
                  </div>)}
              </div>
            </div>

            <Button asChild className="bg-primary text-white hover:bg-primary/90 rounded-lg h-14 px-10 font-sans font-bold uppercase tracking-widest text-xs transition-all shadow-lg">
              <Link to="#start-your-transformation">
                Get a Free Estimate →
              </Link>
            </Button>
          </div>

          {}
          <div className="lg:col-span-7 relative">
            <div className="relative aspect-[4/3] w-full bg-accent/30 border border-border rounded-lg overflow-hidden shadow-xl">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1713190/img/real_calgary_map.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1713190/img/real_calgary_map.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1713190/img/real_calgary_map.png-wvc-sizes" alt="Realistic illustration of Calgary and surrounding service areas with MetalLine branding" className="w-full h-full object-cover" loading="lazy" />
              {}
              <div className="absolute inset-0 pointer-events-none border-[20px] border-white/10" />
            </div>
          </div>
        </div>

        {}
        <div className="mt-24 pt-12 border-t border-border">
          <div className="grid grid-cols-2 md:grid-cols-5 gap-8">
            {trustFeatures.map((feature, i) => <div key={feature.title} data-index={i} className="flex flex-col md:flex-row items-center md:items-start gap-4 text-center md:text-left group">
                <div className="p-2 rounded-lg bg-accent/50 group-hover:bg-primary/10 transition-colors">
                  <feature.icon className="size-6 text-secondary group-hover:text-primary transition-colors" strokeWidth={1.5} />
                </div>
                <div>
                  <h5 className="font-sans font-bold text-sm text-secondary">{feature.title}</h5>
                  <p className="text-xs text-secondary/50 mt-1">{feature.desc}</p>
                </div>
              </div>)}
          </div>
        </div>

        {}
        <div className="mt-16 pt-12 border-t border-border flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
          <div>
            <h3 className="font-sans font-bold text-2xl text-secondary mb-2">
              Ready to Discuss Your Project?
            </h3>
            <p className="font-sans text-secondary/70 text-base">
              Schedule a comprehensive exterior inspection and consultation with our Calgary specialists today.
            </p>
          </div>
          <Button asChild className="bg-primary text-white hover:bg-primary/90 rounded-lg h-14 px-8 font-sans font-bold uppercase tracking-widest text-xs transition-all shadow-lg shrink-0">
            <Link to="#start-your-transformation">
              Book Your On-Site Inspection →
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}